export const enum AuthTokenCookie {
  Access = "access_token",
  Refresh = "refresh_token",
  UserId = "userId",
  UserProvider = "userProvider",
}
